import { Button, type ButtonProps, CircularProgress } from '@mui/material';
import { type FC } from 'react';

interface Props extends ButtonProps {
  loading?: boolean;
  btnColor?: string;
}

export const BaseBtn: FC<Props> = ({
  loading,
  children,
  sx,
  onClick,
  type,
  disabled,
  fullWidth,
  btnColor,
}) => {
  return (
    <Button
      type={type}
      onClick={onClick}
      fullWidth={fullWidth}
      disabled={disabled || loading}
      disableFocusRipple
      sx={{
        textTransform: 'capitalize',
        borderRadius: '0.625rem', // 10px
        height: '2.5rem', // 40px
        px: '0.9375rem', // 15px
        color: btnColor === 'info.main' ? 'primary.dark' : 'info.main',
        borderStyle: `solid`,
        borderWidth: `1px`,
        borderColor:
          btnColor === 'info.main' || !btnColor ? 'primary.dark' : btnColor,
        bgcolor: btnColor ?? 'primary.dark',
        transition: 'all 0.3s',
        '&:hover': {
          bgcolor: btnColor ?? 'primary.dark',
          boxShadow: '0rem 0rem 0.25rem #245AA5', // 0px 0px 4px
        },
        '&:disabled': {
          color: btnColor === 'info.main' ? 'primary.dark' : 'info.main',
          opacity: loading ? 1 : 0.5,
        },
        ...sx,
      }}
    >
      {loading ? (
        <CircularProgress
          size='1.5625rem' // 25px
          sx={{
            color: btnColor === 'info.main' ? 'primary.dark' : 'info.main',
          }}
        />
      ) : (
        children
      )}
    </Button>
  );
};
